import React, { useState } from "react";
import {
  Typography,
  TextField,
  Button,
  Stack,
  Box,
  IconButton,
  List,
  ListItem,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { toastAlert } from "../../../utils/AlertContext";

export const Pay = ({ value = [], onChange }) => {
  const data = value;
  const [title, setTitle] = useState("");
  const [percentage, setPercentage] = useState("");
  const [color, setColor] = useState("#2563eb");

  const handleAdd = () => {
    if (!title.trim()) {
      toastAlert("El título es obligatorio", "warning");
      return;
    }

    if (percentage === "" || percentage === null) {
      toastAlert("El porcentaje es obligatorio", "warning");
      return;
    }

    const numericValue = Number(percentage);

    if (isNaN(numericValue)) {
      toastAlert("El porcentaje debe ser un número válido", "error");
      return;
    }

    if (numericValue < 0 || numericValue > 100) {
      toastAlert("El porcentaje debe estar entre 0 y 100", "warning");
      return;
    }

    const newItem = {
      id: Date.now(),
      name: title.trim(),
      value: numericValue,
      color,
    };

    onChange([...data, newItem]);

    setTitle("");
    setPercentage("");
    setColor("#2563eb");

    toastAlert("Elemento agregado correctamente", "success");
  };

  const handleUpdateItem = (id, field, value) => {
    if (field === "name" && !value.trim()) {
      toastAlert("El título no puede estar vacío", "warning");
      return;
    }

    if (field === "value") {
      const numericValue = Number(value);

      if (isNaN(numericValue)) {
        toastAlert("Debe ser un número válido", "error");
        return;
      }

      if (numericValue < 0 || numericValue > 100) {
        toastAlert("El valor debe estar entre 0 y 100", "warning");
        return;
      }
    }

    const newData = data.map((item) =>
      item.id === id
        ? {
            ...item,
            [field]:
              field === "value"
                ? Number(value)
                : value,
          }
        : item
    );

    onChange(newData);
  };

  const handleDelete = (id) => {
    onChange(data.filter((item) => item.id !== id));
  };

  return (
    <Stack spacing={4} mt={4}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems="center"
      >
        <TextField
          fullWidth
          label="Título"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          size="small"
        />

        <TextField
          fullWidth
          label="Porcentaje"
          type="number"
          value={percentage}
          onChange={(e) => setPercentage(e.target.value)}
          size="small"
          inputProps={{ min: 0, max: 100 }}
        />

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Color:
          </Typography>

          <input
            type="color"
            value={color}
            onChange={(e) => setColor(e.target.value)}
            style={{
              width: "40px",
              height: "40px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              padding: 0,
            }}
          />
        </Box>

        <Button
          variant="contained"
          onClick={handleAdd}
          disabled={!title.trim() || !percentage}
          sx={{
            minWidth: "120px",
            background:
              "linear-gradient(95deg, #2563eb, #1e40af)",
            color: "white",
          }}
        >
          Agregar
        </Button>
      </Stack>

      <Box sx={{ maxHeight: 320, overflowY: "auto" }}>
        <Typography variant="h6" gutterBottom>
          Datos agregados
        </Typography>

        {data.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No hay datos
          </Typography>
        ) : (
          <List>
            {data.map((item) => (
              <ListItem
                key={item.id}
                sx={{
                  borderBottom: "1px solid #f1f5f9",
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                }}
              >
                <input
                  type="color"
                  value={item.color}
                  onChange={(e) =>
                    handleUpdateItem(
                      item.id,
                      "color",
                      e.target.value
                    )
                  }
                  style={{
                    width: "32px",
                    height: "32px",
                    border: "none",
                    cursor: "pointer",
                  }}
                />
                <TextField
                  size="small"
                  label="Título"
                  value={item.name}
                  onChange={(e) =>
                    handleUpdateItem(
                      item.id,
                      "name",
                      e.target.value
                    )
                  }
                  sx={{ flex: 1 }}
                />
                <TextField
                  size="small"
                  label="%"
                  type="number"
                  value={item.value}
                  onChange={(e) =>
                    handleUpdateItem(
                      item.id,
                      "value",
                      e.target.value
                    )
                  }
                  inputProps={{ min: 0, max: 100 }}
                  sx={{ width: 100 }}
                />
                <IconButton
                  onClick={() => handleDelete(item.id)}
                >
                  <DeleteIcon color="error" />
                </IconButton>
              </ListItem>
            ))}
          </List>
        )}
      </Box>
    </Stack>
  );
};
